if (!customElements.get('localization-form')) {

  customElements.define('localization-form', class extends HTMLElement {
    connectedCallback() {
      // Wait for the form to be rendered
      this.waitForForm().then(() => {
        this.initializeElements();
        this.setupEventListeners();
        this.setupRedirectOnSubmit();
      });
    }

    waitForForm() {
      return new Promise((resolve) => {
        const checkForm = () => {
          this.form = this.querySelector('form');
          if (this.form) {
            resolve();
          } else {
            // Retry after a short delay
            setTimeout(checkForm, 50);
          }
        };
        checkForm();
      });
    }

    initializeElements() {
      if (!this.form) {
        console.error('Form not found within localization-form element');
        return;
      }
      this.languageInput = this.form.querySelector('input[name="language_code"]');
      this.countryInput = this.form.querySelector('input[name="country_code"]');
      this.choicesCurrency = this.querySelector('#choices-currency');
      this.choicesLanguage = this.querySelector('#choices-language');
    }

    setupEventListeners() {
      // Wait for choices-select elements to be ready before adding event listeners
      this.waitForChoicesElements().then(() => {
        this.addEventListeners();
      });
    }

    waitForChoicesElements() {
      return new Promise((resolve) => {
        const checkElements = () => {
          if (this.choicesCurrency && this.choicesLanguage) {
            resolve();
          } else {
            // Retry after a short delay
            setTimeout(checkElements, 50);
          }
        };
        checkElements();
      });
    }

    addEventListeners() {
      // Listen for choice-selected events from currency dropdown
      if (this.choicesCurrency) {
        this.choicesCurrency.addEventListener('choice-selected', (event) => {
          // console.log('Currency choice-selected event:', event.detail);
          this.handleCurrencyChoice(event.detail.value);
        });
      }
      // Listen for choice-selected events from language dropdown
      if (this.choicesLanguage) {
        this.choicesLanguage.addEventListener('choice-selected', (event) => {
          // console.log('Language choice-selected event:', event.detail);
          this.handleLanguageChoice(event.detail.value);
        });
      }
    }

    handleCurrencyChoice(value) {
      console.log(value);
      if (value && this.countryInput) {
        this.countryInput.value = value;
        // this.submitForm(); 
      }
    }

    handleLanguageChoice(value) {
      console.log(value);
      if (value && this.languageInput) {
        this.languageInput.value = value;
        // this.submitForm(); 
      }
    }

    submitForm() {
      if (this.form) {
        // If country code is CA, redirect instead of submitting
        if (this.countryInput && this.countryInput.value === 'CA') {
          window.location.href = 'https://vessi-footwear-cad.myshopify.com/';
        } else {
          this.form.submit();
        }
      }
    }

    setupRedirectOnSubmit() {
      if (!this.form) return;
      this.form.addEventListener('submit', (e) => {
        if (this.countryInput && this.countryInput.value === 'CA') {
          e.preventDefault();
          window.location.href = 'https://vessi-footwear-cad.myshopify.com/';
        }
      });
    }
  });
}